// extracted by mini-css-extract-plugin
module.exports = {"bb-country-list-switcher":"bb-country-list-switcher__7Tzg7"};